<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <TableLoading v-if="branch.publicId === '0'"/>
    <div v-else>
      <div class="mx-4">
        <div class="row mb-4">
          <div class="col-md-3">
            <div class="card mini-stats-wid" style="height: 120px">
              <div class="card-body">
                <div class="d-flex">
                  <div class="flex-grow-1" style="max-width:85%; overflow-wrap: break-word;">
                    <h5 class="text-muted fw-medium mb-2">Name</h5>
                    <h4 class="mb-0">{{branch.name}}</h4>
                  </div>

                  <div class="avatar-sm mini-stat-icon rounded-circle">
                    <span class="avatar-title bg-primary">
                      <i class="bx bx-home font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card mini-stats-wid" style="height: 120px">
              <div class="card-body">
                <div class="d-flex">
                  <div class="flex-grow-1" style="max-width:85%; overflow-wrap: break-word;">
                    <h5 class="text-muted fw-medium mb-2">Phone Number</h5>
                    <h4 class="mb-0"> <a :href="'tel:'+branch.phoneNumber"> {{ branch.phoneNumber }} </a> </h4>
                  </div>

                  <div class="avatar-sm mini-stat-icon rounded-circle">
                    <span class="avatar-title bg-info">
                      <i class="bx bx-phone font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card mini-stats-wid" style="height: 120px">
              <div class="card-body">
                <div class="d-flex">
                  <div class="flex-grow-1" style="max-width:85%; overflow-wrap: break-word;">
                    <h5 class="text-muted fw-medium mb-2">Email</h5>
                    <h4 class="mb-0"> <a :href="'mailto:'+branch.email"> {{ branch.email }} </a> </h4>
                  </div>

                  <div class="avatar-sm mini-stat-icon rounded-circle">
                    <span class="avatar-title bg-danger">
                      <i class="bx bx-envelope font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card mini-stats-wid" style="height: 120px">
              <div class="card-body">
                <div class="d-flex">
                  <div class="flex-grow-1" style="max-width:85%; overflow-wrap: break-word;">
                    <h5 class="text-muted fw-medium mb-2">Person in Charge</h5>
                    <h4 class="mb-0" v-if="branch.personInCharge">{{ branch.personInCharge }}</h4>
                    <h4 class="mb-0" v-else> Not Set </h4>
                  </div>
                  <div class="avatar-sm mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-success">
                      <i class="bx bx-clipboard font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-8">
            <div class="card">
              <div class="card-body">
                <div class="row mt-5 h5">
                  <div class="col-5 mb-4"><b>Name:</b></div>
                  <div class="col-6 mb-4">{{ branch.name }}</div>
                  <div class="col-5 mb-4"><b>Email:</b></div>
                  <div class="col-6 mb-4"> <a :href="'mailto:'+branch.email"> {{ branch.email }} </a> </div>
                  <div class="col-5 mb-4"><b>Phone Number:</b></div>
                  <div class="col-6 mb-4"> <a :href="'tel:'+branch.phoneNumber"> {{ branch.phoneNumber }} </a> </div>
                  <div class="col-5 mb-4"><b>Town:</b></div>
                  <div class="col-6 mb-4">{{ branch.town }}</div>
                  <div class="col-5 mb-4"><b>Street:</b></div>
                  <div class="col-6 mb-4">{{ branch.street }}</div>
                  <div class="col-5 mb-4"><b>Address Zone:</b></div>
                  <div class="col-6 mb-4">{{ branch.zoneId.name }}</div>
                  <div class="col-5 mb-4"><b>Address Line:</b></div>
                  <div class="col-6 mb-4">{{ branch.addressLine1 }}</div>
                  <div class="col-5 mb-4"><b>Automatic Discount Percentage:</b></div>
                  <div class="col-6 mb-4">
                    <span v-if="branch.automaticDiscountPrecentage == null">N/A</span>
                    <span v-else>{{ branch.automaticDiscountPrecentage }}</span>
                  </div>
                  <div class="col-5 mb-4"><b>Automatic Surcharge Percentage:</b></div>
                  <div class="col-6 mb-4">
                    <span v-if="branch.automaticSurchargePrecentage == null">N/A</span>
                    <span v-else>{{ branch.automaticSurchargePrecentage }}</span>
                  </div>
                  <div class="col-5 mb-4"><b>Person in Charge:</b></div>
                  <div class="col-6 mb-4">
                    <span v-if="branch.personInCharge">{{ branch.personInCharge }}</span>
                    <span v-else> Not Set </span>
                  </div>
                  <div class="col-5 mb-4"><b>Warehouse Consignee Code:</b></div>
                  <div class="col-6 mb-4">
                    <span v-if="branch.warehouseConsigneeCode">{{ branch.warehouseConsigneeCode }}</span>
                    <span v-else> Not Set </span>
                  </div>
                  
                  <div class="col-5 mb-4"><b>Location:</b></div>
                  <div class="col-6 mb-4">{{ branch.longi }}, {{branch.lat}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4" v-if="branch.contacts.length > 0">
            <div class="px-4 pb-4">
              <h2 class="card-title-desc">Contact Details</h2>
              <div class="card" v-for="contact in branch.contacts" :key="contact.publicId">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="avatar-md me-4">
                          <span
                              class="avatar-title rounded-circle bg-light text-danger font-size-16"
                          >
                            <img src="@/assets/images/FullKikkomanLogo.png" alt height="30" />
                          </span>
                    </div>

                    <div class="flex-grow-1 overflow-hidden">
                      <h5 class="text-truncate font-size-15">
                        <a href="javascript: void(0);" class="text-dark">{{contact.name}}</a>
                      </h5>
                      <p class="text-muted mb-1"> <a :href="'mailto:'+contact.email"> {{contact.email}} </a> </p>
                      <p> <a :href="'tel:'+contact.phoneNumber"> {{ contact.phoneNumber }} </a> </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-5" v-if="branch.ordersPaginated.objects.length > 0">
        <div class="px-4 pb-4">
          <h2 class="card-title-desc">Orders Details</h2>
          <div class="card">
            <div class="card-body">
              <data-table :columns="columns" :rows="branch.ordersPaginated.objects" :current-page="orderCurrentPage" :has-pagination="false" @onSearch="searchFn">
                <template v-slot:actions="slotProps" v-if="checkForPermission(view_single_order_permission)">
                  <b-button variant="info" size="sm" class="py-1 text-white" @click="viewOrderInvoice(slotProps.row.publicId)">
                    View Order Invoice
                  </b-button>
                </template>
              </data-table>
              <b-pagination
                  v-model="orderCurrentPage"
                  :total-rows="branch.ordersPaginated.total"
                  :per-page="perPage"
                  size="lg"
                  align="center"
                  class="mt-3"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {SINGLE_CUSTOMER_BRANCH} from "@/gql/customers";
import DataTable from "@/components/data-table";
import {routeItems} from "@/router/endpoints";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";

export default {
  page: {
    title: "Single Branch",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, DataTable, PageHeader, Layout},
  name: "single-branch",
  data() {
    return {
      title: "Single Branch",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Single Branch",
          active: true
        }
      ],
      view_single_order_permission: permissions.view_single_order_permission,
      columns: [
        {
          field: 'invoiceId',
          label: 'Invoice ID'
        },
        {
          field: 'orderedBy',
          label: 'Ordered By'
        },
        {
          field: 'createdAt',
          label: 'Order Date'
        },
        {
          field: 'orderTotal',
          label: 'Order Total'
        },
        {
          field: 'deliveryDate',
          label: 'Delivery Date'
        },
        {
          field: 'paymentReceivedDate',
          label: 'Payment Received date'
        },
        {
          field: 'status',
          label: 'Status'
        },
        {
          field: 'actions',
          label: 'Action'
        }
      ],
      orderCurrentPage: 1,
      perPage: 30,
      orderSearchKeyword: '',
      branch: {
        publicId: '0',
        name: "",
        institutionId: {
          publicId: "",
          name: ""
        },
        zoneId: {
          publicId: "",
          name: "",
        },
        phoneNumber: "",
        email: "",
        addressLine1: "",
        town: "",
        street: "",
        longi: "",
        lat: "",
        automaticDiscountPrecentage: "",
        contacts: [
          {
            publicId: "",
            name: "",
            phoneNumber: "",
            email: "",
          }
        ],
        ordersPaginated: {
          total: "",
          objects: []
        }
      }
    }
  },
  apollo: {
    branch: {
      query: SINGLE_CUSTOMER_BRANCH,
      variables(){
        return {
          id: this.$route.params.id,
          orderCurrentPage: this.orderCurrentPage,
          orderSearchKeyword: this.orderSearchKeyword
        }
      }
    }
  },
  watch: {
    orderCurrentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  mounted() {
    this.orderCurrentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    viewOrderInvoice(public_id){
      this.$router.push(routeItems.customer_order_invoice_route+'/'+public_id)
    },
    searchFn(data){
      this.orderSearchKeyword = data
    }
  }

}
</script>

<style scoped>

</style>
